import React from "react";
import { Button, Form, Modal } from 'react-bootstrap';
import * as PSLib from "poolside-js-lib";
import Locale from "../../locale";



export default class ConfiguratorAddDevice extends React.Component {
    state = {
        record: {
            deviceType: undefined,
            brandId: undefined,
            primaryCatalogId: undefined,
            secondaryCatalogId: undefined,
            CompatibleBrandId: undefined,
            ColorAndShowLibraryId: undefined,
            // ColorAndShowSelectionMethodId: undefined,
            portType: undefined,
            uuid: undefined,
        },
        dropdownOptions: {
            deviceTypes: Object.values(PSLib.PoolDevice.PoolDeviceTypes)
                .filter(item => ![
                    PSLib.Config.DeviceTypes.CLEANER,
                    PSLib.Config.DeviceTypes.DOORSENSOR,
                    PSLib.Config.DeviceTypes.FLOWRELAY,
                    PSLib.Config.DeviceTypes.FILTER,
                    PSLib.Config.DeviceTypes.LIGHTDRIVER,
                    PSLib.Config.DeviceTypes.PRESSURESENSOR,
                    PSLib.Config.DeviceTypes.SOLARHEATER,
                    PSLib.Config.DeviceTypes.T
                ].includes(item.default.DeviceType))
                .sort((a,b) => a.default.PickerTitle > b.default.PickerTitle ? 1 : -1)
                .map(item => ({ value: item.default.DeviceType, label: item.default.PickerTitle }))
            ,
            brands: [],
            primaryCatalogIds: [],
            ColorAndShowLibraryIds: [],
            // ColorAndShowSelectionMethodIds: [],
            portTypes: [],
        }
    }

    load(record) {
        if (record.deviceType === PSLib.Config.DeviceTypes.LIGHT) {
            this.onChange(record, true);
        } else {
            const catalogEntry = PSLib.Catalog.getCatalogEntryByDeviceConfig(this.getMockConfigFromRecord(record));
            this.onChange({ ...record, brandId: catalogEntry?.brand }, true);
        }
    }

    getMockConfigFromRecord(record) {
        return {
            DeviceType: record?.deviceType,
            HardwareDevice: {
                LightSettings: {
                    CompatibleBrandId: record?.CompatibleBrandId,
                    ColorAndShowLibraryId: record?.ColorAndShowLibraryId,
                    // ColorAndShowSelectionMethodId: record?.ColorAndShowSelectionMethodId,
                },
                PrimaryCatalogId: record?.primaryCatalogId,
                SecondaryCatalogId: record?.secondaryCatalogId,
            }
        };
    };

    /**
     * 
     * @param {*} change Change to apply for `this.state.record`
     * @param {boolean} clear Set to true to avid merging in current record to `change`.
     */
    onChange(change, clear) {
        console.debug("[ConfigurateorAddDevice] onCange() record:", change);
        this.setState(prev => {
            const record = clear ? change : Object.assign(prev.record, change);
            const dropdownOptions = Object.assign(prev.dropdownOptions, {
                brands: [],
                primaryCatalogIds: [],
                ColorAndShowLibraryIds: [],
                // ColorAndShowSelectionMethodIds: [],
                portTypes: [],
            });

            const catalog = PSLib.Catalog.getCatalogByDeviceType(record.deviceType);

            // brands
            catalog?.forEach(itemCatalog => {
                let brandName;
                let brandId;
                if (record.deviceType === PSLib.Config.DeviceTypes.LIGHT) {
                    brandName = itemCatalog.name;
                    brandId = itemCatalog.id;
                } else {
                    brandName = itemCatalog.brand;
                    brandId = itemCatalog.brand;
                }
                if (!dropdownOptions.brands.some(item => item.value === brandId)) {
                    dropdownOptions.brands.push({ value: brandId, label: brandName });
                };
            });
            dropdownOptions.brands.sort((a,b) => a.label > b.label ? 1 : -1);
            if (!dropdownOptions.brands.map(item => item.value).includes(record.brandId)) {
                record.brandId = undefined;
            }
            if (!dropdownOptions.brands.map(item => item.value).includes(record.CompatibleBrandId)) {
                record.CompatibleBrandId = undefined;
            }
            if (dropdownOptions.brands.length === 1) {
                record.brandId = dropdownOptions.brands[ 0 ].value
            }

            
            // ColorAndShowLibraryIds
            if (record.CompatibleBrandId) {
                const lightFamily = catalog?.find(item => item.id === record.CompatibleBrandId);

                dropdownOptions.ColorAndShowLibraryIds = lightFamily?.colorAndShowLibraries?.map(item => ({ value: item.id, label: item.name })) || [];
                
                // ColorAndShowSelectionMethodIds
                /*
                if (record.ColorAndShowLibraryId) {
                    const colorAndShowLibrary = lightFamily?.colorAndShowLibraries?.find(item => item.id === record.ColorAndShowLibraryId);
                    if (colorAndShowLibrary) {
                        dropdownOptions.ColorAndShowSelectionMethodIds = colorAndShowLibrary.selectionMethods?.map(item => ({ value: item.id, label: (item.name ?? "") + " " + (item.description ?? "") }));
                    }
                }
                */
            }
            if (!dropdownOptions.ColorAndShowLibraryIds.map(item => item.value).includes(record.ColorAndShowLibraryId)) {
                record.ColorAndShowLibraryId = undefined;
            }
            /*
            if (!dropdownOptions.ColorAndShowSelectionMethodIds.map(item => item.value).includes(record.ColorAndShowSelectionMethodId)) {
                record.ColorAndShowSelectionMethodId = undefined;
            }
            */

            // primaryCatalogIds
            if (record.brandId) {
                catalog
                    ?.filter(item => item.brand === record.brandId)
                    ?.forEach(itemCatalog => {
                        if ((record.deviceType === PSLib.Config.DeviceTypes.HEATER && itemCatalog.deviceType !== "HEATER") ||
                            (record.deviceType === PSLib.Config.DeviceTypes.HEATPUMP && itemCatalog.deviceType !== "HEATPUMP")    
                        ) return;
                        if (!dropdownOptions.primaryCatalogIds.some(item => item.value === itemCatalog.model)) {
                            dropdownOptions.primaryCatalogIds.push({
                                value: itemCatalog.itemId,
                                label: (itemCatalog.model ?? "") + " " + (itemCatalog.description ?? "")
                            });
                        };
                    })
                ;
                dropdownOptions.primaryCatalogIds.sort((a,b) => a.label > b.label ? 1 : -1);
                if (dropdownOptions.primaryCatalogIds.length === 1) {
                    record.primaryCatalogId = dropdownOptions.primaryCatalogIds[ 0 ].value
                }
            }
            if (!dropdownOptions.primaryCatalogIds.map(item => item.value).includes(record.primaryCatalogId)) {
                record.primaryCatalogId = undefined;
            }

            const mockConfig = this.getMockConfigFromRecord(record);
            dropdownOptions.portTypes = PSLib.Config.getPrimaryPortPortTypes(mockConfig)
                ?.map(item => ({ value: item, label: PSLib.Config.getPortTypeLocalised(item) }))
                ?.sort((a,b) => a.label > b.label ? 1 : -1)
                || []
            ;
            if (!dropdownOptions.portTypes.map(item => item.value).includes(record.portType)) {
                record.portType = undefined;
            }
            if (dropdownOptions.portTypes.length === 1) {
                record.portType = dropdownOptions.portTypes[ 0 ].value
            }

            return {
                record,
                dropdownOptions,
            };
        });
    }

    render () {
        console.debug("[ConfiguratorAddDevice] redner() state:", this.state);

        const isBrandVisible = [
            PSLib.Config.DeviceTypes.ACTUATORTHREEWAY,
            PSLib.Config.DeviceTypes.ACTUATORTWOWAY,
            PSLib.Config.DeviceTypes.CHILLER,
            PSLib.Config.DeviceTypes.CHLORINESENSOR,
            PSLib.Config.DeviceTypes.FLOWMETER,
            PSLib.Config.DeviceTypes.HEATER,
            PSLib.Config.DeviceTypes.HEATPUMP,
            PSLib.Config.DeviceTypes.LIGHTDRIVER,
            PSLib.Config.DeviceTypes.PUMP,
            PSLib.Config.DeviceTypes.REMOTE,
            PSLib.Config.DeviceTypes.SALTCELL,
        ].includes(this.state.record.deviceType);

        const isCompatibleBrandIdVisible = [
            PSLib.Config.DeviceTypes.LIGHT,
        ].includes(this.state.record.deviceType);

        const isModelVisible = isBrandVisible;

        const isColorAndShowLibraryIdVisible = [
            PSLib.Config.DeviceTypes.LIGHT,
        ].includes(this.state.record.deviceType);

        /*
        const isColorAndShowSelectionMethodIdVsible = [
            PSLib.Config.DeviceTypes.LIGHT,
        ].includes(this.state.record.deviceType);
        */

        const isPortTypeVisible = [
            PSLib.Config.DeviceTypes.ACTUATORTHREEWAY,
            PSLib.Config.DeviceTypes.ACTUATORTWOWAY,
            PSLib.Config.DeviceTypes.AUTOFILL,
            PSLib.Config.DeviceTypes.BLOWER,
            PSLib.Config.DeviceTypes.BUTTON,
            PSLib.Config.DeviceTypes.CHEMICALPUMP,
            PSLib.Config.DeviceTypes.CHILLER,
            PSLib.Config.DeviceTypes.CHLORINESENSOR,
            PSLib.Config.DeviceTypes.COVER,
            PSLib.Config.DeviceTypes.FIRE,
            PSLib.Config.DeviceTypes.FILLSWITCH,
            PSLib.Config.DeviceTypes.FLOWMETER,
            PSLib.Config.DeviceTypes.FLOWSWITCH,
            PSLib.Config.DeviceTypes.GENERICONOFF,
            PSLib.Config.DeviceTypes.HEATER,
            PSLib.Config.DeviceTypes.HEATPUMP,
            PSLib.Config.DeviceTypes.LIGHT,
            PSLib.Config.DeviceTypes.LIGHTDRIVER,
            PSLib.Config.DeviceTypes.ORPPROBE,
            PSLib.Config.DeviceTypes.OZONATOR,
            PSLib.Config.DeviceTypes.PHPROBE,
            PSLib.Config.DeviceTypes.PUMP,
            PSLib.Config.DeviceTypes.REMOTE,
            PSLib.Config.DeviceTypes.SALTCELL,
            PSLib.Config.DeviceTypes.THERMISTOR,
            PSLib.Config.DeviceTypes.UVSANITIZER,
            PSLib.Config.DeviceTypes.WATERLEVELSENSOR,
        ].includes(this.state.record.deviceType);

        const isWaterLevelSensorPortTypeVisible = [
            PSLib.Config.DeviceTypes.WATERLEVELSENSOR,
        ].includes(this.state.record.deviceType);
        
        return <Modal show={ this.props.visible } onHide={ this.props.onClose }>
            <Modal.Header closeButton>
                <Modal.Title>{ Locale.gettext("Select Device") }</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column gap-3">
                <Form.Group>
                    <Form.Label>{ Locale.gettext("Category") }:</Form.Label>
                    <Form.Select name="category" value={ this.state.record.deviceType } onChange={ evt => this.onChange({ deviceType: evt.target.value }) }>
                        <option></option>
                        { this.state.dropdownOptions.deviceTypes?.map(item => <option value={ item.value } key={ item.value }>{ item.label }</option>) }
                    </Form.Select>
                </Form.Group>
                { isBrandVisible && <Form.Group>
                    <Form.Label>{ Locale.gettext("Brand") }:</Form.Label>
                    <Form.Select value={ this.state.record.brandId } onChange={ evt => this.onChange({ brandId: evt.target.value }) }>
                        <option></option>
                        { this.state.dropdownOptions.brands?.map(item => <option value={ item.value } key={ item.value }>{ item.label }</option>) }
                    </Form.Select>
                </Form.Group> }
                { isCompatibleBrandIdVisible && <Form.Group>
                    <Form.Label>{ Locale.gettext("Brand") }:</Form.Label>
                    <Form.Select value={ this.state.record.CompatibleBrandId } onChange={ evt => this.onChange({ CompatibleBrandId: evt.target.value }) }>
                        <option></option>
                        { this.state.dropdownOptions.brands?.map(item => <option value={ item.value } key={ item.value }>{ item.label }</option>) }
                    </Form.Select>
                </Form.Group> }
                { isModelVisible && <Form.Group>
                    <Form.Label>{ Locale.gettext("Model") }:</Form.Label>
                    <Form.Select value={ this.state.record.primaryCatalogId } onChange={ evt => this.onChange({ primaryCatalogId: evt.target.value }) }>
                        <option></option>
                        { this.state.dropdownOptions.primaryCatalogIds?.map(item => <option value={ item.value } key={ item.value }>{ item.label }</option>) }
                    </Form.Select>
                </Form.Group> }
                { isColorAndShowLibraryIdVisible && <Form.Group>
                    <Form.Label>{ Locale.gettext("Expected Colors and Shows") }:</Form.Label>
                    <Form.Select value={ this.state.record.ColorAndShowLibraryId } onChange={ evt => this.onChange({ ColorAndShowLibraryId: evt.target.value }) }>
                        <option></option>
                        { this.state.dropdownOptions.ColorAndShowLibraryIds?.map(item => <option value={ item.value } key={ item.value }>{ item.label }</option>) }
                    </Form.Select>
                </Form.Group> }
                {/* isColorAndShowSelectionMethodIdVsible && <Form.Group>
                    <Form.Label>{ Locale.gettext("Off/On Timing (Advanced)") }:</Form.Label>
                    <Form.Select value={ this.state.record.ColorAndShowSelectionMethodId } onChange={ evt => this.onChange({ ColorAndShowSelectionMethodId: evt.target.value }) }>
                        <option></option>
                        { this.state.dropdownOptions.ColorAndShowSelectionMethodIds?.map(item => <option value={ item.value } key={ item.value }>{ item.label }</option>) }
                    </Form.Select>
                </Form.Group> */}
                { isPortTypeVisible && <Form.Group>
                    <Form.Label>{ Locale.gettext("Connection Port") }:</Form.Label>
                    <Form.Select value={ this.state.record.portType } onChange={ evt => this.onChange({ portType: evt.target.value }) }>
                        <option></option>
                        { this.state.dropdownOptions.portTypes?.map(item => <option value={ item.value } key={ item.value }>{ item.label }</option>) }
                    </Form.Select>
                </Form.Group> }
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={ this.props.onClose }>
                { Locale.gettext("Cancel") }
            </Button>
            <Button variant="primary" onClick={ () => {
                if (!this.state.record.portType) {
                    alert(Locale.gettext("Please select Connection Port"));
                    return;
                }
                this.props.onSave({
                    deviceType: this.state.record.deviceType,
                    primaryCatalogId: this.state.record.primaryCatalogId,
                    secondaryCatalogId: this.state.record.secondaryCatalogId,
                    CompatibleBrandId: this.state.record.CompatibleBrandId,
                    ColorAndShowLibraryId: this.state.record.ColorAndShowLibraryId,
                    // ColorAndShowSelectionMethodId: this.state.record.ColorAndShowSelectionMethodId,
                    portType: this.state.record.portType,
                    uuid: this.state.record.uuid,
                });
                this.props.onClose();
            } }>
                { Locale.gettext("Save") }
            </Button>
            </Modal.Footer>
        </Modal>;
    }
}
